import { api } from "../api";

export const sendReport = async (dateStr) => {
  let url = `/report/${dateStr}`;
  return await api.get(url);
};
  